// IBS-3 — İşletme Bilgileri turu (Sirket-Sayfasi/IBS-ISLETME-BILGILERI-PLANI.md §7). Ekran başına en çok 3 balon.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
export default {
  isletmeBilgi: {
    yol: "/ayarlar/isletme",
    adimlar: [
      { hedef: '[data-tur="ibs-logo"]', metin: "Logonuz menüde, fişte ve maillerde görünür. Seçtiğiniz an kaydedilir." },
      { hedef: '[data-tur="ibs-adres"]', metin: "Fişte ve müşteriye giden maillerde bu adres yazar." },
      { hedef: '[data-tur="ibs-kaydet"]', metin: "Ad, telefon, e-posta ve adres değişikliklerini buradan kaydedin." },
    ],
  },
};
